import styled from 'styled-components';
import { CarouselSlideMixin } from '../../mixins/components/CarouselSlideMixin';
import { Flex } from '../Flex/Flex';
export var StyledCarouselSlide = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "StyledCarouselSlide",
  componentId: "c11n-8-111-1__sc-1p640hm-0"
})(["", ""], CarouselSlideMixin);